export default {
  "content": "<path fill=\"currentcolor\" d=\"M6 10.44a1.69 1.69 0 100-3.38 1.69 1.69 0 000 3.38zm0 5.37a1.69 1.69 0 100-3.37 1.69 1.69 0 000 3.37zM6 5.06A1.69 1.69 0 106 1.7a1.69 1.69 0 000 3.37zm5.38 5.38a1.69 1.69 0 100-3.38 1.69 1.69 0 000 3.38zm0 5.37a1.69 1.69 0 100-3.37 1.69 1.69 0 000 3.37zm0-10.75a1.69 1.69 0 100-3.37 1.69 1.69 0 000 3.37z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "viewBox": "0 0 18 18"
  }
};